export const defaultSelectedModel = () => {
  return {
    pay_taxes: null
  };
};

export default {
  cartInitial: [],
  cart: {
    bulletin: null,
    percentage_discount: null,
    documents_information: {
      price_list: ""
    }
  },
  total: 0,
  pdf: "",
  show_pdf: false,
  error: false,
  errorMessage: "",
  params:{
    user_connect: []
  },
  last_cart: {
    parameter: {
      name_parameter: ""
    }
  },
  selected_model: defaultSelectedModel(),
  lockAdd: false,
  lockPromotions: false,
  pathPdf:null,

  // Pedido Sugerido AI / Pedido Ideal
  resume_ai: [],
  suggestedProductPurchaseDaysQuantities: [],
  suggestedProductSeasonality: [],
  suggestedProductLastSale: {},
  suggestedProductSalesCompany: [],
  resumeProductAi: {},
  resumeProductQuantityAi: {},
  error_revalue_document: false,
  cart_suggested: {
    documents_product: [],
    documents_information: {
      price_list: ''
    },
    price_lists: []
  },
  brandSublineCategoryRelations: [],
  cartSuggestedProducts: []
};



// WEBPACK FOOTER //
// ./src/b2b/modules/cart/state.js